import { triggerGamificationRule } from "../../utils/fw"


const changeMeeting = (id) => {
	document.getElementById("engagement-sessions-screen").src = `https://embedplayer.evia.events/tkeventsbreakoutdemo${id}?autoplay=true&muted=false`
}

export default {
	background: "https://assets.swoogo.com/uploads/full/1455989-6182d217a77f4.jpg",
	extras: (
		<>
			<iframe allowfullscreen frameborder="0" id="engagement-sessions-screen"
				style={{
					width: "calc(50.9% * 1.33333)",
					height: "calc(57.8% * 1.33333)",
					left: "24.5%",
					top: "6.8%",
					position: "absolute",
					cursor: "pointer",
					display: "block",
					zIndex: "5",
					overflow: "hidden",
					transformOrigin: "top left",
					transform: "scale(0.75)",
				}}
				src=""
			/>
		</>
	),
	links: [
		{
			label: "To Lobby",
			href: "/lobby",
			width: "16.4%",
			height: "9.3%",
			left: "40.9%",
			top: "87.9%",
		},
		{
			label: "Demo 1",
			width: "14.3%",
			height: "17.2%",
			left: "5.3%",
			top: "13.5%",
			onClick: () => { changeMeeting("1") }
		},
		{
			label: "QA 1",
			CometChatID: "hr",
			width: "11.6%",
			height: "5.4%",
			left: "7.1%",
			top: "31.1%",
		},
		{
			label: "Demo 2",
			width: "14.3%",
			height: "17%",
			left: "5.3%",
			top: "38.6%",
			onClick: () => { changeMeeting("2") }
		},
		{
			label: "QA 2",
			CometChatID: "insurance",
			width: "11%",
			height: "5.6%",
			left: "7.2%",
			top: "56.1%",
		},
		{
			label: "Demo 3",
			width: "14.1%",
			height: "16.9%",
			left: "80.9%",
			top: "13.8%",
			onClick: () => { changeMeeting("3") }
		},
		{
			label: "QA 3",
			CometChatID: "flex",
			width: "10.7%",
			height: "6.3%",
			left: "82.6%",
			top: "31.1%",
		},
		{
			label: "Demo 4",
			width: "14.6%",
			height: "17%",
			left: "80.6%",
			top: "38.5%",
			onClick: () => { changeMeeting("4") }
		},
		{
			label: "QA 4",
			CometChatID: "banking",
			width: "11.1%",
			height: "5.6%",
			left: "82.6%",
			top: "55.7%",
		},
	],
	name: "demo-theatre",
}
